/**
 * Sequence — Unreal's Sequence node: one exec in, N exec outs ("Then 0..N-1"),
 * fired in order, every time.
 *
 * Each output runs to completion SYNCHRONOUSLY before the next starts, which is
 * the same as Unreal: an async node on one output (Delay, Smooth Damp, a walk)
 * schedules its continuation and returns, so the next output fires straight
 * away rather than waiting for it.
 *
 * Output COUNT is data.count, clamped here so the node and the runtime agree on
 * which pins exist. Shrinking below a wired pin leaves that edge dangling (the
 * same rule Merge follows), and the runtime only walks the pins that exist, so
 * a hidden pin never fires.
 *
 * Pin ids start with "exec" because graphConnectPolicy identifies exec pins by
 * that prefix — that is what gives each output its one-wire capacity.
 */

export const SEQUENCE_MIN_OUTPUTS = 2
export const SEQUENCE_MAX_OUTPUTS = 16

export function sequenceCount(data) {
  const n = Math.trunc(Number(data?.count))
  if (!Number.isFinite(n)) return SEQUENCE_MIN_OUTPUTS
  return Math.min(SEQUENCE_MAX_OUTPUTS, Math.max(SEQUENCE_MIN_OUTPUTS, n))
}

export function sequenceHandle(i) {
  return `execThen${i}`
}

/** Handle ids in firing order. */
export function sequenceHandles(data) {
  return Array.from({ length: sequenceCount(data) }, (_, i) => sequenceHandle(i))
}
